import type { FC, MouseEventHandler, ReactNode } from 'react';

import { ButtonKinds } from 'types/button';
import { twMergeClsx } from 'utils/tw-with-clsx';
import { DynamicTagButton } from 'views/shared/dynamic-tag-button';
import { SpinnerIcon } from 'views/shared/spinner-icon';

interface ButtonProps {
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  href?: string;
  kind?: ButtonKinds;
}

const buttonStyles =
  'w-full text-center h-[46px] rounded-[20px] px-4 py-3 text-base font-semibold transition-colors disabled:opacity-60';
const buttonPrimaryStyles =
  'active:bg-sz-yellow-400 hover:bg-sz-yellow-300 bg-sz-yellow-200 text-sz-black';
const buttonSecondaryStyles =
  'bg-white md:bg-sz-gray-100 hover:bg-sz-gray-400 active:bg-sz-gray-600 text-sz-black';

const Button: FC<ButtonProps> = ({
  children,
  onClick,
  className,
  isLoading,
  href,
  kind = ButtonKinds.primary,
  disabled,
}) => {
  const classes = twMergeClsx(
    buttonStyles,
    kind === ButtonKinds.primary && buttonPrimaryStyles,
    kind === ButtonKinds.secondary && buttonSecondaryStyles,
    className,
  );

  return (
    <DynamicTagButton
      href={href}
      disabled={disabled || isLoading}
      className={classes}
      onClick={onClick}
    >
      {isLoading ? <SpinnerIcon /> : children}
    </DynamicTagButton>
  );
};

export { Button };
